export default __webpack_public_path__ + "static/media/woocommerce.cec101a3.svg";